import { Component, OnInit, Input } from '@angular/core';
import { IStep } from '@models/step-container.model';
import { StepperService } from '@services/step-container.service';
import { RestService } from '@services/rest.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'step-container',
  templateUrl: './step-container.component.html',
  styleUrls: [ 'step-container.component.scss' ]
})
export class StepContainerComponent implements OnInit {
  @Input() public selectedStep: IStep;
  @Input() public flow: 'General' | 'Enroll' = 'General';

  constructor(public stepperService: StepperService, private restService: RestService, private translate: TranslateService) {
    this.restService.setDefaultLanguage();
    this.stepperService.stepChanged.subscribe((step: IStep) => {
      this.selectedStep = step;
      console.log(this.selectedStep);
    });
  }

   loop (i:number) {
     var x = this;    
    i++;
    console.log(i, x.selectedStep.header);
    if (i<=20) {
        setTimeout(function() {
          if (x.selectedStep.header && x.selectedStep.header.indexOf("Step")!=-1)
            x.translate.get(x.selectedStep.header).subscribe((data)=>{ x.selectedStep.header = data});
          if (x.selectedStep.subHeader && x.selectedStep.subHeader.indexOf("Step")!=-1)
            x.translate.get(x.selectedStep.subHeader).subscribe((data)=>{ x.selectedStep.subHeader = data});
          if (x.selectedStep.name && x.selectedStep.name.indexOf("Step")!=-1)
            x.translate.get(x.selectedStep.name).subscribe((data)=>{ x.selectedStep.name = data});      
          console.log(i, x.selectedStep.header);
          x.loop(i)
        }, 500);
      }
  }
  ngOnInit() {
    //this.loop(0);
  }

  public getSteps() {
    return this.stepperService.steps.filter(a => !a.hide);;
  }

  public stepChanged(step: IStep) {
    if (step.canActivate) {
      this.stepperService.setCurrentStep(step);
      this.stepperService.disbaleActivateFurtherSteps(step);
    }
  }
}